import React from 'react'
import { useSelector } from 'react-redux'
import { useSelectorDelegateStore } from 'reduxes/stores/root_store/hooks'

import {
  getCurrentHandle,
  isConfirmedSelector,
} from '../../reduxes/slices/current/selectors'
import { isLiveChatApp } from '../../reduxes/slices/live_chat_app/selectors'

export const ConfirmEmailBanner = () => {
  const isConfirmed = useSelectorDelegateStore(isConfirmedSelector)
  const handle = useSelector(getCurrentHandle)
  const liveChatApp = useSelectorDelegateStore(isLiveChatApp)

  return liveChatApp || isConfirmed ? null : (
    <div className={'confirm__email__banner'}>
      <span className="far fa-envelope confirm__email__banner__icon" />
      {`Great! We’ve sent an email to ${handle}. Click the link in that email to unlock all the features of ${
        (window as any).appName
      }.️`}
    </div>
  )
}
